var _path, _path2, _path3, _path4, _path5, _path6;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGerman(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 512,
    height: 512,
    viewBox: "0 0 512 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M 0.004 360.250 C 0.007 408.328, 0.057 409.581, 2.082 412.903 C 4.904 417.531, 7.724 419.665, 12.693 420.931 C 18.591 422.435, 493.409 422.435, 499.307 420.931 C 504.437 419.624, 506.924 417.664, 510.358 412.224 L 513 408.040 512.760 358.770 L 512.520 309.500 512.250 357.265 L 511.981 405.030 284.740 404.765 C 57.500 404.500, 57.500 404.500, 51 402.275 C 35.473 396.960, 23.038 384.218, 18.593 369.068 C 17.313 364.705, 17 358.460, 17 337.318 L 17 311 8.500 311 L 0 311 0.004 360.250 M 0.464 360.500 C 0.464 388, 0.592 399.106, 0.749 385.180 C 0.906 371.255, 0.906 348.755, 0.749 335.180 C 0.592 321.606, 0.464 333, 0.464 360.500",
    stroke: "none",
    fill: "#ffd064",
    fillRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M 0 256 L 0 311 7.983 311 L 15.967 311 16.233 256 L 16.500 201 8.250 201 L 0 201 0 256",
    stroke: "none",
    fill: "#db4655",
    fillRule: "evenodd"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M 11.951 91.371 C 7.172 92.891, 4.683 94.827, 2.140 99 C 0.040 102.447, 0.007 103.242, 0.004 151.790 L 0 201.081 8.250 200.790 L 16.500 200.500 16.759 146.059 C 16.901 116.116, 16.676 91.308, 16.259 90.930 C 15.841 90.552, 13.903 90.751, 11.951 91.371",
    stroke: "none",
    fill: "#4b3f4e",
    fillRule: "evenodd"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M 17 337.318 C 17 358.460, 17.313 364.705, 18.593 369.068 C 23.038 384.218, 35.473 396.960, 51 402.275 C 57.500 404.500, 57.500 404.500, 284.750 404.765 L 512 405.030 512 358.015 L 512 311 264.500 311 L 17 311 17 337.318",
    stroke: "none",
    fill: "#ffe07d",
    fillRule: "evenodd"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M 16.667 201.667 C 16.300 202.033, 16 226.783, 16 256.667 L 16 311 264 311 L 512 311 512 256 L 512 201 264.667 201 C 128.633 201, 17.033 201.300, 16.667 201.667",
    stroke: "none",
    fill: "#e3626b",
    fillRule: "evenodd"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M 16.500 145.500 L 16.500 201 264.250 201 L 512 201 511.996 151.750 C 511.993 103.672, 511.943 102.419, 509.918 99.097 C 507.096 94.469, 504.276 92.335, 499.307 91.069 C 496.390 90.325, 422.292 90, 255.807 90 L 16.500 90 16.500 145.500",
    stroke: "none",
    fill: "#5b5363",
    fillRule: "evenodd"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGerman);
export default __webpack_public_path__ + "static/media/german.1a51549cbb7a5c6c36b9fc8ace9f2b54.svg";
export { ForwardRef as ReactComponent };